import { addSingleObjectToReducer, getSingleObject, removeFailedRequest, removeOpenRequest } from 'ClientService/ReducerUtil/ReducerUtil';
import {
  LOGOUT_USER, AUTHENTICATE_FAILURE,

  FIND_TABLE_ENTRIES_REQUEST,
  FIND_TABLE_ENTRIES_SUCCESS,
  FIND_TABLE_ENTRIES_FAILURE,

  FIND_TABLE_CONFIGS_REQUEST,
  FIND_TABLE_CONFIGS_SUCCESS,
  FIND_TABLE_CONFIGS_FAILURE,

  UPDATE_TABLE_CONFIG_REQUEST,
  UPDATE_TABLE_CONFIG_SUCCESS,
  UPDATE_TABLE_CONFIG_FAILURE,

  UPDATE_COLUMN_CONFIG_REQUEST,
  UPDATE_COLUMN_CONFIG_SUCCESS,
  UPDATE_COLUMN_CONFIG_FAILURE,

  FIND_TABLE_COLUMNS_CONFIG_FOR_USER_REQUEST,
  FIND_TABLE_COLUMNS_CONFIG_FOR_USER_SUCCESS,
  FIND_TABLE_COLUMNS_CONFIG_FOR_USER_FAILURE,

  CHANGE_TABLE_SETTINGS,

} from 'Redux/Action';
import TableStore              from 'Redux/Store/Table/TableStore';

const initialState = TableStore.getInitialState();

export const tableReducer = (state = initialState, action) => {

  switch (action.type) {

    case AUTHENTICATE_FAILURE :
    case LOGOUT_USER :
      return {
        ...initialState,
      };

    case FIND_TABLE_ENTRIES_REQUEST:
    case UPDATE_COLUMN_CONFIG_REQUEST:
    case UPDATE_TABLE_CONFIG_REQUEST:
    case FIND_TABLE_COLUMNS_CONFIG_FOR_USER_REQUEST:
    case FIND_TABLE_CONFIGS_REQUEST:
      return {
        ...state,
        openRequests: [...state.openRequests, action.type],
        failedRequests: removeFailedRequest(action, state),
        updatedAt: Date.now(),
      };

    case FIND_TABLE_CONFIGS_SUCCESS:
    case UPDATE_TABLE_CONFIG_SUCCESS:
    case UPDATE_COLUMN_CONFIG_SUCCESS:
      const tableEntry = getSingleObject(action.payload.tableEntry);

      return {
        ...state,
        openRequests: removeOpenRequest(action, state),
        updatedAt: Date.now(),
        lastInteractiveConfigId: tableEntry?.updatedConfigId || null,
        tableEntries: addSingleObjectToReducer(state.tableEntries, tableEntry),
      };

    case FIND_TABLE_ENTRIES_SUCCESS:
      return {
        ...state,
        openRequests: removeOpenRequest(action, state),
        tableEntries: action.payload.tableEntries,
        updatedAt: Date.now(),
      };

    case FIND_TABLE_COLUMNS_CONFIG_FOR_USER_SUCCESS:
      return {
        ...state,
        openRequests: removeOpenRequest(action, state),
        tableColumns: {
          ...state.tableColumns,
          [action.payload.tableKey]: action.payload.tableColumns,
        },
        updatedAt: Date.now(),
      };

    case CHANGE_TABLE_SETTINGS: {
      const { table, ...payload } = action.payload;
      return {
        ...state,
        tables: {
          ...state.tables,
          [action.payload.table]: {
            ...state.tables[action.payload.table],
            ...payload
          },
        }
      }
    }

    case FIND_TABLE_ENTRIES_FAILURE:
    case UPDATE_TABLE_CONFIG_FAILURE:
    case UPDATE_COLUMN_CONFIG_FAILURE:
    case FIND_TABLE_COLUMNS_CONFIG_FOR_USER_FAILURE:
    case FIND_TABLE_CONFIGS_FAILURE:
      return {
        ...state,
        openRequests: removeOpenRequest(action, state),
        failedRequests: [...state.failedRequests, action.type],
        updatedAt: Date.now(),
      };


    default:
      return state;
  }
};
